const c = {
  name: "Beer",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23.5,5h-0.6c-0.5-2.8-3-5-5.9-5c-2.2,0-4.1,1.2-5.1,2.9C11,1.7,9.6,1,8,1C5.6,1,3.5,2.8,3.1,5.1
			C1.3,5.5,0,7.1,0,9c0,1.9,1.3,3.5,3.1,3.9c0.2,0.9,0.6,1.9,1.4,2.8c0.1,1,0.3,2.1,0.6,3.3c0.2,0.8,0.3,1.5,0.5,2.3
			C6.2,23.6,7,26,8,28.2V40h14V28.2c1-2.2,1.8-4.6,2.4-6.9c0.2-0.8,0.4-1.5,0.5-2.3c0.4-1.9,0.7-3.8,0.8-5.6
			c0.3-0.2,0.6-0.4,0.9-0.7c0.8-0.8,1.3-1.9,1.3-3.1V9.5C28,7,26,5,23.5,5L23.5,5z M20.1,27.6L20,27.8V38H10V27.8l-0.1-0.2
			C9,25.5,8.2,23.3,7.6,21h14.8C21.8,23.3,21,25.5,20.1,27.6z M23,18.6c0,0.1-0.1,0.3-0.1,0.4H7.1c0-0.1-0.1-0.3-0.1-0.4
			c-0.1-0.6-0.2-1.2-0.3-1.7C7.1,16.9,7.5,17,8,17c1.3,0,2.6-0.5,3.5-1.5c0.7-0.7,1.2-1.6,1.4-2.6c0.6,0.5,1.3,0.8,2.1,1V14
			c0,1.6,1.4,3,3,3s3-1.4,3-3v-0.8c0.7,0.5,1.6,0.8,2.6,0.8c0,0,0.1,0,0.1,0C23.6,15.5,23.4,17,23,18.6L23,18.6z M26,9.6
			c0,0.6-0.2,1.2-0.7,1.7c-0.4,0.5-1,0.7-1.8,0.7c-1.4,0-2.5-1.1-2.5-2.5V9h-2v5c0,0.5-0.5,1-1,1c-0.6,0-1-0.5-1-1v-2h-1
			c-1.7,0-3-1.3-3-3h-2v3c0,0.8-0.3,1.6-0.9,2.1C9.6,14.7,8.8,15,8,15c-2.8,0-3-2.5-3-3v-1H4c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2h1V6
			c0-1.6,1.3-3,3-3s3,1.4,3,3h2c0-2.2,1.8-4,4-4s4,1.8,4,4v1h2.5C24.9,7,26,8.1,26,9.6L26,9.6L26,9.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Beer
};
